import {get, post} from '../index'

export default {
  // 获取官网列表
  getWebsiteList (querys) {
    return get('/website/adminOff', querys)
  },
  getWebsiteDiySelect (querys) {
    return get('/website/adminOffV2', querys)
  },
  getWebsiteFormInfo (querys) {
    return get('/website/modularInfo', querys)
  },
  // 修改官网信息
  editWebsiteInfo (querys) {
    return post('/website/modular_update', querys)
  },
  // 添加官网信息
  addWebsiteInfo (querys) {
    return post('/website/adminOff', querys)
  },
  // 删除官网信息
  delWebsiteInfo (querys) {
    return post('/website/modular_del', querys)
  },
  // 上下架官网模块
  updetaWebsite (querys) {
    return post('/website/lower', querys)
  },
  // 获取官网内容列表
  getWebsiteContentList (querys) {
    return get('/website/modular_read', querys)
  },
  // 获取内容详情数据(内容编辑回显)
  getWebsitContentInfo (querys) {
    return get('/website/modularContentInfo', querys)
  },
  // 官网内容上下架、删除
  updateWebsiteContentInfo (querys) {
    return post('/website/updateJob', querys)
  },
  // 修改官网内容详情的信息（编辑后提交）
  editWebsiteContentInfo (querys) {
    return post('/website/updateContent', querys)
  },
  // 添加官网内容详情信息 （添加提交）
  addWebsiteContentInfo (querys) {
    return post('/website/createContent', querys)
  },
  // 站点绑定数据回显和编辑
  getEditSiteInfo (querys) {
    return post('/card/admin/websitebind', querys)
  },
  // 视频分类列表
  websiteVideoCategory (querys) {
    return get('/website/video/category', querys)
  },
  // 添加分类
  websiteVideoAddCategory (querys) {
    return post('/website/video/addCategory', querys)
  },
  // 删除分类
  websiteVideoDelCategory (querys) {
    return post('/website/video/deleteCategory', querys)
  },
  // 编辑分类
  websiteVideoUpdateCategory (querys) {
    return post('/website/video/updateCategory', querys)
  },
  // 是否显示分类
  websiteVideoStatusCategory (querys) {
    return post('/website/video/statusCategory', querys)
  },
  // 获取所有视频分类
  websiteVideoCategoryAll (querys) {
    return get('/website/video/category_all', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/website.js